import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  HwDbDashboardProvider,
  HwDbDashboardStore,
} from '../../providers/hwDbDashboard';
import {
  ACCOUNT_ACTIVITY_ROUTE,
  COBRA_BENEFITS_ENROLLMENT_ROUTE,
  HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE,
  HEALTH_SUMMARY,
  LIFE_EVENTS_ROUTE,
  PAYMENT_INFO_ROUTE,
  PENSION_PROFILE_ROUTE,
  PROFILE_ROUTE,
} from '../../routes/types';
import { DateFormats, formatDate } from '../../utils/utils';
import CurrentAccruedPension from '../widgets/dashboards/CurrentAccruedPension';
import HealthSavingsAndSpending from '../widgets/dashboards/HealthSavingsAndSpending';
import HealthSnapshot from '../widgets/dashboards/HealthSnapshot';

const accruedPensionData = [
  {
    title: 'HRA',
    subtitle: 'Health Reimbursement Arrangement',
    priceDescription: 'Available',
    balance: 2339.18,
  },
];

const linksDataCurrentAccruedPension = [
  {
    linkHeader: 'Account Activity',
    route: ACCOUNT_ACTIVITY_ROUTE,
  },

  {
    linkHeader: 'Pension Profile',
    route: PENSION_PROFILE_ROUTE,
  },
];

const linksData = [
  {
    linkHeader: 'More Details',
    route: `${HEALTH_SUMMARY}`,
  },

  {
    linkHeader: 'Change Coverage',
    route: `${LIFE_EVENTS_ROUTE}`,
  },

  {
    linkHeader: 'Payment Information',
    route: `${PAYMENT_INFO_ROUTE}`,
  },

  {
    linkHeader: 'Beneficiaries',
    route: `${PROFILE_ROUTE.slice(0, 9)}beneficiaries`,
  },

  {
    linkHeader: 'Family Members',
    route: `${PROFILE_ROUTE.slice(0, 9)}familymembers`,
  },
];

const currentAccruedPensionData = [
  {
    title: 'Cash Balance Pension',
    subtitle: `As of ${formatDate(new Date(), DateFormats.SHORT)}`,
    monthlyBenefitPriceDescription: 'Pay Age 65',
    balance: 53185.62,
    monthlyBenefit: 355.21,
  },
  {
    title: 'Qualified Plan',
    subtitle: `As of ${formatDate(new Date(), DateFormats.SHORT)}`,
    monthlyBenefitPriceDescription: 'Pay Age 65',
    balance: '',
    monthlyBenefit: 2643.98,
  },
  {
    title: 'Non-Qualified Plan',
    subtitle: `As of ${formatDate(new Date(), DateFormats.SHORT)}`,
    monthlyBenefitPriceDescription: 'Pay Age 65',
    balance: '',
    monthlyBenefit: 602.95,
  },
];

const HwDbInactiveDashboardView = () => {
  const { fingertipLinks, companiesMessages, coveredFamilyMembers } =
    useContext(HwDbDashboardStore) || {};
  const navigate = useNavigate();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">COBRA Benefit Information</div>
            }
            leftSubheading={
              <div className="text-sm-12-lg-14 fw-light mb-7">
                You are eligible to enroll in COBRA continuation coverage for
                yourself and your eligible dependents.
              </div>
            }
            button={
              <Button
                className="align-self-end"
                variant="primary-shadow"
                size="sm"
                onClick={() => navigate(COBRA_BENEFITS_ENROLLMENT_ROUTE)}
              >
                Enroll Now
              </Button>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column h-100"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row className="text-sm-12-lg-14 p-0">
                  <Col className=" text-nowrap col-12 fw-light">
                    There are currently no events.
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col className="m-0 p-0 mt-12 mt-lg-8 pt-lg-8 col-12 col-lg-7 pe-lg-4">
          <HealthSnapshot
            coveredFamilyMembers={coveredFamilyMembers}
            linksData={linksData}
          />
        </Col>
        <Col className="m-0 p-0 mt-12 mt-lg-8 pt-lg-8 col-12 col-lg-5 ps-lg-6">
          <FingerTipsLinks data={fingertipLinks} />
        </Col>
      </Row>

      <Row className="m-0 p-0 d-flex justify-content-between">
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 pe-lg-4'
          }
        >
          <CurrentAccruedPension
            currentAccruedPensionData={currentAccruedPensionData}
            linksData={linksDataCurrentAccruedPension}
          />
        </Col>
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 ps-lg-4'
          }
        >
          <HealthSavingsAndSpending
            detailsRoute={HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE}
            accruedPensionData={accruedPensionData}
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const HwDbDashboardInactive = () => {
  return (
    <HwDbDashboardProvider>
      <HwDbInactiveDashboardView />
    </HwDbDashboardProvider>
  );
};

export default HwDbDashboardInactive;
